import { DefaultLayout } from '@/shared/ui/DefaultLayout'
import { ProgressBar } from '@/shared/ui/ProgressBar'
import { ApiError } from '@/shared/lib/http'
import type { OrgNewDraft } from '@/public/features/org/types'
import { CARD_STEPS, ORG_LAST_STEP } from '@/public/features/org/constants/orgNew'
import { Buttons } from '@/public/features/org/ui/orgNew/parts'
import { CardDone, DoneButtons, OrgDone } from '@/public/features/org/ui/orgNew/Done'
import { StepType } from '@/public/features/org/ui/orgNew/steps/StepType'
import { StepInfo } from '@/public/features/org/ui/orgNew/steps/StepInfo'
import { StepIntro } from '@/public/features/org/ui/orgNew/steps/StepIntro'
import { StepManager } from '@/public/features/org/ui/orgNew/steps/StepManager'
import { StepCardContent } from '@/public/features/org/ui/orgNew/steps/StepCardContent'
import { StepCardCategory } from '@/public/features/org/ui/orgNew/steps/StepCardCategory'
import { StepCardTarget } from '@/public/features/org/ui/orgNew/steps/StepCardTarget'
import { StepCardHelp } from '@/public/features/org/ui/orgNew/steps/StepCardHelp'
import { StepCardResource } from '@/public/features/org/ui/orgNew/steps/StepCardResource'
import { StepCardScope } from '@/public/features/org/ui/orgNew/steps/StepCardScope'

export function OrgNewMobile({ draft }: { draft: OrgNewDraft }) {
  const headTitle =
    draft.stage === 'form' && draft.step <= ORG_LAST_STEP
      ? '기업 등록'
      : draft.stage === 'org-done'
        ? '기업 등록'
        : '해결 카드 등록'

  return (
    <DefaultLayout
      mobileTitle={headTitle}
      className="relative flex h-[100dvh] flex-col md:flex"
    >
      {draft.stage === 'form' ? (
        <ProgressBar
          step={draft.step > ORG_LAST_STEP ? draft.step - ORG_LAST_STEP : draft.step}
          total={draft.step > ORG_LAST_STEP ? CARD_STEPS : ORG_LAST_STEP}
          className="layout-body"
        />
      ) : null}

      <div
        data-scroll-root
        className="layout-body flex min-h-0 flex-1 shrink-0 grow basis-0 flex-col gap-[45px] overflow-y-auto px-4 pt-3 pb-4"
      >
        {draft.stage === 'org-done' ? (
          <OrgDone />
        ) : draft.stage === 'card-done' ? (
          <CardDone />
        ) : (
          <Step draft={draft} />
        )}

        {draft.error !== null && draft.error !== undefined ? (
          <p className="m-0 text-body-sm text-[#f54550]" role="alert">
            <b>등록하지 못했습니다.</b>{' '}
            {draft.error instanceof ApiError && draft.error.detail.length > 0
              ? draft.error.detail.join(' · ')
              : '잠시 후 다시 시도해 주세요.'}
          </p>
        ) : null}
      </div>

      {draft.stage === 'form' ? <Buttons draft={draft} /> : <DoneButtons draft={draft} />}
    </DefaultLayout>
  )
}

export function Step({ draft }: { draft: OrgNewDraft }) {
  switch (draft.step) {
    case 1:
      return <StepType draft={draft} />
    case 2:
      return <StepInfo draft={draft} />
    case 3:
      return <StepIntro draft={draft} />
    case 4:
      return <StepManager draft={draft} />
    case 5:
      return <StepCardContent draft={draft} />
    case 6:
      return <StepCardCategory draft={draft} />
    case 7:
      return <StepCardTarget draft={draft} />
    case 8:
      return <StepCardHelp draft={draft} />
    case 9:
      return <StepCardResource draft={draft} />
    default:
      return <StepCardScope draft={draft} />
  }
}
